// extracted by mini-css-extract-plugin
module.exports = {"vipCardMobile":"VipCardMobile_vipCardMobile__3hq80","cardLogo":"VipCardMobile_cardLogo__3ju5G"};